import { render, staticRenderFns } from "./MDKTable2.vue?vue&type=template&id=5cb12ee2&scoped=true&"
import script from "./MDKTable2.vue?vue&type=script&lang=js&"
export * from "./MDKTable2.vue?vue&type=script&lang=js&"
import style0 from "./MDKTable2.vue?vue&type=style&index=0&id=5cb12ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb12ee2",
  null
  
)

export default component.exports